import request from "@/dianwuyi/request";
import * as wx_work from "@/dianwuyi/wx-work"
import axios from "axios";

/**
 * @method
 * @param {String} queryName
 * @param {Object} queryParam 可传 key:value
 * @returns {Object} {StdQuery:Array,StdQuerySum:Object} <br/> {StdQuery:[],StdQuerySum:{}}
 */
export async function getStdQueryData(queryName, queryParam) {
    if (queryParam == undefined) queryParam = {};

    if (queryParam.pageNo) {
        queryParam.start = (queryParam.pageNo - 1) * queryParam.pageSize;
        queryParam.length = queryParam.pageSize;
    }
    if (wx_work.getToken()) {
        queryParam.UserId = wx_work.getToken()
    }

    var _data = await request({
        url: "/miniAppApi/apiGet/query/" + queryName,
        method: "get",
        params: JSON.parse(JSON.stringify(queryParam))
    });
    return _data.data;
}

export function getDataObjectScript(objectName) {
    return request({
        url: "/miniAppApi/apiGet/dataObject/" + objectName,
        method: "get"
    });
}

/**
 * @method
 * @param {String} objectName
 * @param {Object} queryParam 可传 key:value
 * @param {Object} entity 把对象传进来，如遇相同属性直接赋值
 * @returns {Object} {key:value,$1:Array,$2:Array} <br/> {key:value,$1:[],$2:[]}
 */
export async function getDataObjectData(objectName, queryParam, entity) {
    if (queryParam == undefined) queryParam = {};
    if (queryParam.pageNo) {
        queryParam.start = (queryParam.pageNo - 1) * queryParam.pageSize;
        queryParam.length = queryParam.pageSize;
    }
    if (wx_work.getToken()) {
        queryParam.UserId = wx_work.getToken()
    }
    let _data = await request({
        url: "/miniAppApi/apiGet/dataObject/" + objectName,
        method: "get",
        params: JSON.parse(JSON.stringify(queryParam))
    });
    if (entity) {
        for (let d in _data.data) {
            if (entity[d] instanceof Object && !(entity[d] instanceof Array)) continue
            entity[d] = _data.data[d];
        }
    }
    return _data.data;
}

/**
 * @method
 * @param {String} businessId
 * @param {Object} data 可传 key:value key:array <br/> {a:1,b:'2',c:[5,6,7]}
 * @returns {Object}
 */
export async function postBusiness(businessId, data) {

    if (wx_work.getToken()) {
        data.UserId = wx_work.getToken()
    }

    let x = await request({
        url: "/miniAppApi/apiPost/" + businessId,
        method: "post",
        data
    });

    if (x.success) {
        vant.Toast('操作成功');

    } else {
        vant.Toas(x.message);
    }
    return x;
}

export function uploadFile(data) {
    return request({
        headers: {
            "Content-Type": "multipart/form-data"
        },
        url: "/frameVue/uploadFile",
        method: "post",
        data
    });
}

export function exportStdQueryData(
    moduleId,
    queryName,
    queryParam,
    reportName,
    fileName
) {
    if (queryParam == undefined) queryParam = {};
    queryParam._ReportName = reportName;
    queryParam._ExportFileName = fileName;

    return request({
        url: "/export/slstd/" + moduleId + "/" + queryName,
        method: "get",
        responseType: "arraybuffer",
        params: queryParam
    });
}

/**
 *
 * @param page 页面 pages/index/index
 * @param params 参数 a=1
 */
export function getMiniAppQRCode(page, scene) {
    return request({
        url: "/miniApp/getQRCode",
        method: "post",
        data: {
            page: page,
            scene: scene
        }
    });
}

export function existsMobile(mobile) {
    return request({
        url: "/userApi/existsMobile",
        method: "post",
        params: {
            mobile: mobile,
        },
    });
}

export function exportFileBlob(url, fileName) {
    return new Promise(async (resolve, reject) => {
        const token = store.getters['user/token']
        axios({
            url: process.env.VUE_APP_API_BASE + url,
            method: "post",
            responseType: 'blob',
            headers: {"Authorization": token}
        }).then(res => {
            const url = window.URL.createObjectURL(res.data);
            const elink = document.createElement('a');
            elink.href = url;
            elink.target = '_self'; // 当前也 target打开新页面
            elink.setAttribute('download', fileName);
            elink.style.display = 'none';
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
            resolve()
        }).catch(() => {
            reject()
        })
    })

}

export async function getConfig(code) {
    let _data = await getStdQueryData("PC_Config", {Code: code})
    let _returnData = {}
    for (let i = 0; i < _data.StdQuery.length; i++) {
        _returnData[_data.StdQuery[i].Code] = _data.StdQuery[i].Value
    }
    return _returnData
}

export function modifyConfig(code, value) {
    return postBusiness("PC_MerchantConfigModifyV", {
        Code: code,
        Value: value
    })
}
